import ChevronDownIcon from '@lemon8/design/lib/icons/icon_assets/chevron_down_fill.svg';
import { Loading } from '~/components/loading';
import { useTranslation } from 'react-i18next';
import cls from 'classnames';
import { ClickPosition } from '~/utils/click-position';
import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { $CurrentPageModule } from '~/models/current-page-module';
import { $CurrentPositionPrefix } from '~/models/current-position-prefix';

import './style.scss';

interface SeeMoreProps {
  loading?: boolean;
  onClickSeeMore?: () => void;
}

export const SeeMore = (props: SeeMoreProps): JSX.Element => {
  const { onClickSeeMore, loading = false } = props;
  const { t } = useTranslation();
  const currentPageModule = useScopedAtomValue($CurrentPageModule);
  const prefix = useScopedAtomValue($CurrentPositionPrefix);

  const onClick = () => {
    window.Tea('wap_click', {
      current_page_module: currentPageModule,
      current_position: prefix + ClickPosition.see_more_button,
    });

    onClickSeeMore?.();
  };

  return (
    <div className={cls('see-more', { 'see-more-loading': loading })} onClick={onClick}>
      {loading ? (
        <Loading variant={'ball'} />
      ) : (
        <>
          <span>{t('see_more')}</span>
          <ChevronDownIcon />
        </>
      )}
    </div>
  );
};
